<template>
	<div>
	<p class="mw-h3">{{name}}</p>
	<div v-if="importProps">
		<v-dialog v-model="dialog">
			<template v-slot:activator="{ on }">
				<v-btn small color="accent" dark v-on="on" class="ml-2">
					Import
				</v-btn>
			</template>
			<v-card>
				<Import v-bind="importProps" v-on:complete="imported" ></Import>								
			</v-card>
		</v-dialog>			
	</div>
	<v-simple-table>
		<thead>
			<tr>
				<th class="text-center" v-for="(column, index) in columns" :key="index"> {{ column.name }}</th>
				<th class="text-center"></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(item, index) in items" :key="index">
				<td class="pt-2" v-for="(column, index) in columns" :key="index">
					<span class="mb-5 text-large" v-if="column.type == 'automatic'">{{column.function(item)}}</span>
					<EditableTableField v-else :column="column" :item="item"></EditableTableField>
				</td>
				<td>
					<v-btn icon @click="deleteItem(index)">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</td>
			</tr>
		</tbody>
	</v-simple-table>
	<p class="text-right mt-2 mr-4"><v-btn color="primary" @click="addItem">Add {{single}}</v-btn></p>
	</div>

</template>
<script>
	import EditableTableField from "../tools/EditableTableField.vue"
	import Import from "../tools/Import.vue";
	export default {
		name: "AddManyTable",
		props: {
			importProps: {type: Object },
			items: {type: Array, default: () => [] },
			columns: {type: Array, default: () => [] },
			name: {type: String },
			single: {type: String, default: 'item'}
		},
		components: {
			EditableTableField: EditableTableField,
			Import: Import
		},
		data: () => {
			return {
				dialog: false
			}
		},
		methods: {
			imported(output){
				const self = this;
				self.dialog = false;
				output.forEach( a => self.items.push( a ))
			},
			addItem(){
				let item = {}
				this.columns.forEach( c => {
					item[c.value] = "";
				})
				this.items.push(item)
			},
			deleteItem(index){
				this.items.splice( index, 1 )
			}
		}
	}	
</script>